// Testimonials.js
import React, { useEffect, useRef, useState } from "react";
import Tilt from "react-parallax-tilt";
import "bootstrap/dist/css/bootstrap.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import "./Testimonials.css";



export default function Testimonials() {
    const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

  const testimonials = [
  {
    name: "Sanjay Kumar",
    // title: "Designer",
    image: "men.png",
    text: "I truly appreciate how the team explained the vision for Aanandam Valleey. The focus on wellness and heritage in a peaceful setting in Barsana is exactly what my family was looking for.",
  },
  {
    name: "Pooja Sharma",
    // title: "Marketing",
    image: "women.png",
    text: "The process with the property team was very professional and efficient. Investing in a plot so close to Shri Radha Rani Mandir is a dream come true",
  },
  {
    name: "Rajeshwari Reddy",
    // title: "Developer",
    image: "women.png",
    text: "Aanandam Valleey's commitment to sustainability, with rainwater harvesting and tree plantation, convinced us this is a forward-thinking and beautiful place to build our home.",
  },
  {
    name: "Aman Singh",
    // title: "Designer",
    image: "men.png",
    text: "We finally found our dream home location at Aanandam Valleey. The idea of having a community that values cultural events and togetherness makes this more than just an investment.",
  },
  {
    name: "Divya Mehta",
    // title: "Marketing",
    image: "women.png",
    text: "The detailed information on the clubhouse, parks, and security made us feel secure in our decision. It's a fantastic blend of modern amenities and spiritual significance.",
  },
  {
    name: "Sunil Yadav",
    // title: "Developer",
    image: "men.png",
    text: "I am happy with the team's support throughout. The location's connectivity and the master plan for the Braj region make Aanandam Valleey a very promising choice for our future.",
  },
];
  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.index);
            setVisibleCards((prev) =>
              prev.includes(idx) ? prev : [...prev, idx]
            );
          }
        });
      },
      { threshold: 0.3 }
    );

    cardRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);
  return (
    <section className="bg-testimonials text-center" data-aos="fade-up">
      <div>
        <button id="subtitle" className="btn btn-sm mb-2 details-btn">
          Testimonials
        </button>

        <h2 className="testimonial-sub-heading">A way of life, the world's greatest fellow</h2>
      </div>
      <div className="container g-1 px-3">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          // slidesPerView={1}
          loop={true}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 3 },
            1092: { slidesPerView: 4 },
            1400: { slidesPerView: 4 },
          }}
          // autoHeight={true}

          className="testimonial-swiper"
        >
          {testimonials.map((t, i) => (
            // Make SwiperSlide a flex item and flex container
            <SwiperSlide key={i} className="d-flex">
              <Tilt
                glareEnable={true}
                glareMaxOpacity={0.2}
                scale={1.02}
                transitionSpeed={300}
                tiltMaxAngleX={10}
                tiltMaxAngleY={10}
                className=" swiper-horizontal d-flex flex-column"
              >
                {/* testimonial-card fills its parent */}
                <div className="testimonial-card flex-fill position-relative d-flex flex-column">
                  {/* <span className="quote-icon">
                <img
                  src="/inverted-commas.png"
                  alt="quote comma"
                  height="30"
                  width="30"
                />
              </span> */}
                  <div className="card-body d-flex flex-column">
                    <div className="d-flex align-items-center mb-2 gap-3">
                      <img
                        src={`${IMAGE_BASE_URL}/${t.image}`}
                        alt={t.name}
                        className="rounded-circle avatar "
                        width="50"
                        height="50"
                      />
                      <div className="text-start flex-grow-1">
                        <h5 className="mb-0">{t.name}</h5>
                        <small className="text-muted">{t.title}</small>
                      </div>
                    </div>
                    {/* Make text area flex-grow to push footer (if any) down */}
                    <p className="card-text flex-grow-1 mt-1">{t.text}</p>
                    {/* Optional footer (e.g., “Read more” or date) */}
                    {/* <div className="mt-2">...</div> */}
                  </div>
                </div>
              </Tilt>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
